export default "__VITE_ASSET__BgLR7zjo__"